var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import './index.css';
import Select from 'react-select';
import { SeatZone } from '../Model';
import { Button } from '../../../elements';
import { Container, Label, Row } from 'reactstrap';
import { Input } from 'reactstrap';
import { T } from 'helpers/i18n';
import ColorPicker from '../../../components/ColorPicker';
import Zone from '../../../components/Zone';
var Mapsite = /** @class */ (function (_super) {
    __extends(Mapsite, _super);
    function Mapsite(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            seatAreaSelected: null,
            inputData: '',
            seatAreaAdded: [],
            seatAreas: [],
            displayColorPicker: false,
        };
        _this.handleChange = function (color, name) {
            console.log('handleChange - color: ', color);
            if (name === 'background') {
                _this.backColor = color;
            }
            else if (name === 'font') {
                _this.fontColor = color;
            }
            if (_this.state.seatAreaSelected) {
                var seatAreaSelected = _this.state.seatAreaSelected;
                if (name === 'background') {
                    seatAreaSelected.backgroundColor = color;
                }
                else if (name === 'font') {
                    seatAreaSelected.fontColor = color;
                }
                _this.setState({ seatAreaSelected: seatAreaSelected });
            }
        };
        _this.handleClickEdit = function (seatAreaSelected) {
            if (_this.state.seatAreaSelected && seatAreaSelected.name === _this.state.seatAreaSelected.name) {
                return _this.setState({ seatAreaSelected: null });
            }
            _this.backColor = seatAreaSelected.backgroundColor;
            _this.fontColor = seatAreaSelected.fontColor;
            _this.setState({ seatAreaSelected: seatAreaSelected });
        };
        _this.handleResizeStop = function (e, dir, elementRef, delta, position, index) {
            _this.mapSite[index].position = position;
            _this.mapSite[index].size.height = Number(_this.mapSite[index].size.height) + delta.height;
            _this.mapSite[index].size.width = Number(_this.mapSite[index].size.width) + delta.width;
            _this.props.onResized(_this.mapSite);
        };
        _this.handleDragStop = function (e, data, index) {
            _this.mapSite[index].position = { x: data.x, y: data.y };
            _this.props.onDragged(_this.mapSite);
        };
        _this.handleEdit = function () {
            var selected = _this.state.seatAreaSelected;
            console.log('handleEdit - selected: ', selected);
            var item = _this.mapSite.find(function (seatZone) { return seatZone.name === selected.name; });
            console.log('item: ', item);
            item.name = _this.state.inputData;
            console.log('this.mapSite: ', _this.mapSite);
        };
        _this.handleAdd = function () {
            var _a = _this.state, seatAreas = _a.seatAreas, seatAreaAdded = _a.seatAreaAdded, inputData = _a.inputData;
            if (inputData === '') {
                return;
            }
            // compruebo si está
            var encontrado = false;
            seatAreas.forEach(function (seatarea) {
                if (inputData.toLowerCase() === seatarea.name.toLowerCase()) {
                    encontrado = true;
                }
            });
            if (!encontrado) {
                var temp = new SeatZone({
                    id: _this.state.seatAreas.length + 1,
                    enabled: true,
                    rows: [],
                    position: { x: 0, y: 300 },
                    size: { width: 100, height: 100 },
                    name: inputData,
                    backgroundColor: _this.backColor,
                    fontColor: _this.fontColor
                });
                seatAreas.push(temp);
                seatAreaAdded.push(temp);
                _this.setState({ seatAreas: seatAreas, seatAreaAdded: seatAreaAdded });
            }
            else {
                alert('esa zona ya existe');
            }
        };
        _this.handleInputOnChange = function (e) {
            _this.setState({ inputData: e.target.value });
        };
        _this.handleSelectOnChange = function (value, action) {
            console.log('value: ', value);
            // console.log('action: ', action)
            var seatAreaAdded = value.map(function (item) {
                // console.log('handleSelectOnChange - item: ', item)
                if (item.value.name === value) {
                    if (action.action === 'select-option') {
                        item.value.enabled = true;
                    }
                    else if (action.action === 'remove-value') {
                        item.value.enabled = false;
                    }
                }
                return item.value;
            });
            _this.setState({ seatAreaAdded: seatAreaAdded }, function () {
                console.log('seatAreaAdded despues: ', _this.state.seatAreaAdded);
                _this.mapSite.forEach(function (seatZone, index, array) {
                    seatZone.enabled = !!_this.state.seatAreaAdded.find(function (seatZoneAdded) { return seatZoneAdded.name === seatZone.name; });
                });
            });
        };
        _this.state.seatAreas = _this.props.mapSite;
        _this.mapSite = _this.props.mapSite;
        /*this.options = this.state.seatAreas.map(seatArea => ({
          value: seatArea, label: seatArea.name
        }))*/
        console.log('mapSite: ', _this.mapSite);
        _this.state.seatAreas.forEach(function (seatArea) {
            if (seatArea.enabled) {
                _this.state.seatAreaAdded.push(seatArea);
            }
        });
        return _this;
    }
    Mapsite.prototype.componentDidMount = function () {
        var seatAreaSelected = this.state.seatAreaSelected;
        this.backColor = seatAreaSelected ? seatAreaSelected.backgroundColor : '#fff';
        this.fontColor = seatAreaSelected ? seatAreaSelected.fontColor : '#000';
    };
    Mapsite.prototype.render = function () {
        var _this = this;
        var _a = this.state, seatAreaAdded = _a.seatAreaAdded, seatAreaSelected = _a.seatAreaSelected, inputData = _a.inputData;
        var added = seatAreaAdded.map(function (seatArea) { return ({
            value: seatArea, label: seatArea.name
        }); });
        this.options = this.state.seatAreas.map(function (seatArea) { return ({
            value: seatArea, label: seatArea.name
        }); });
        return (React.createElement(Container, null,
            React.createElement(Row, null,
                React.createElement("div", { style: { display: 'flex', justifyContent: 'flex-start', alignItems: 'center', backgroundColor: 'whiteSmoke', width: '100%', margin: '30px' } },
                    React.createElement(Input, { style: { width: '300px' }, placeholder: T('namezone'), defaultValue: seatAreaSelected ? seatAreaSelected.name : '', onChange: this.handleInputOnChange }),
                    React.createElement("div", { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', margin: '0 20px' } },
                        React.createElement(Label, null, 'color de fondo'),
                        React.createElement(ColorPicker, { color: this.backColor, name: 'background', onChangeColor: this.handleChange })),
                    React.createElement("div", { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', margin: '0 20px' } },
                        React.createElement(Label, null, 'color de texto'),
                        React.createElement(ColorPicker, { color: this.fontColor, name: 'font', onChangeColor: this.handleChange })),
                    !seatAreaSelected && React.createElement(Button, { disabled: inputData === '', onClick: this.handleAdd }, T('add')),
                    seatAreaSelected && React.createElement(Button, { onClick: this.handleEdit }, T('aplicar')))),
            React.createElement(Select, { options: this.options, value: added, isMulti: true, onChange: this.handleSelectOnChange }),
            React.createElement("div", { className: "box", style: { height: '763px', width: '100%', position: 'relative', overflow: 'auto', padding: '0' } }, seatAreaAdded.map(function (seatArea, index) {
                var selected = seatAreaSelected && seatArea.name === seatAreaSelected.name;
                return (React.createElement(Zone, { key: seatArea.name, seatArea: seatArea, seatAreaSelected: seatAreaSelected, index: index, onClickEdit: _this.handleClickEdit, onResizeStop: function (e, dir, elementRef, delta, position) {
                        _this.handleResizeStop(e, dir, elementRef, delta, position, index);
                    }, onDragStop: function (e, data) { return _this.handleDragStop(e, data, index); } }));
            }))));
    };
    return Mapsite;
}(Component));
export default Mapsite;



//////////////////
// WEBPACK FOOTER
// ./src/modules/SeatingAreas/container/Mapsite.tsx
// module id = 1286
// module chunks = 0